import React, { useContext } from "react"
import { ThemeContext, ThemeProvider, ThemeProviderProps } from "styled-components"
import { BrandThemes } from "./brand-themes"
import { VibezTheme } from "./theme"

interface Props extends ThemeProviderProps<VibezTheme> {
  className?: string
}

export const VibezThemeProvider = (props: Props) => {
  const { children, ...otherProps } = props
  return (
    <ThemeProvider {...otherProps}>
      <BrandThemes>{children}</BrandThemes>
    </ThemeProvider>
  )
}

export function useVibezTheme() {
  return useContext(ThemeContext)
}
